import React from 'react';
import { PowerIcon } from '@phosphor-icons/react';
import { useCurrentUser } from '../../../../../contexts/UserContext';
import { useViewerStore } from '../../../../../store/store';
import { EditorIconTooltip } from '../../EditorIconTooltip';

interface DashboardOneButtonPeekButtonProps {
    isDashboardOpen?: boolean;
    setIsDashboardOpen?: (next: boolean | ((prev: boolean) => boolean)) => void;
}

/** Opens the full oneBUTTON dashboard from the top menubar section (above AI designs). */
export const DashboardOneButtonPeekButton: React.FC<DashboardOneButtonPeekButtonProps> = ({
    isDashboardOpen: isDashboardOpenProp,
    setIsDashboardOpen: setIsDashboardOpenProp,
}) => {
    const { hasCapability } = useCurrentUser();
    const isDashboardOpenFromStore = useViewerStore((state) => Boolean(state.isDashboardOpen));
    const isViewportOnlyEmbed = useViewerStore((state) => Boolean(state.isViewportOnlyEmbed));
    const isDashboardOpen =
        typeof isDashboardOpenProp === 'boolean' ? isDashboardOpenProp : isDashboardOpenFromStore;

    if (!hasCapability('Show_OneButton')) return null;
    if (isViewportOnlyEmbed) return null;
    if (isDashboardOpen) return null;

    const openDashboard = () => {
        if (setIsDashboardOpenProp) {
            setIsDashboardOpenProp(true);
            return;
        }
        useViewerStore.setState({ isDashboardOpen: true });
    };

    return (
        <EditorIconTooltip title="oneBUTTON dashboard" zone="sidebar">
            <button
                type="button"
                className="obd-onebutton-peek"
                onClick={openDashboard}
                aria-label="Open oneBUTTON dashboard"
            >
                <span className="left-menu-icon-wrapper obd-onebutton-peek__icon">
                    <PowerIcon size={24} weight="bold" aria-hidden />
                </span>
            </button>
        </EditorIconTooltip>
    );
};
